<template>
  <div :class="['report-emitidos-container', $vuetify.theme.dark ? 'dark-mode' : '']">
    <!-- CABECERA PROFESIONAL 🏛️ -->
    <header class="audit-header d-flex align-center pa-4">
      <div class="header-left d-flex align-center">
        <h1 :class="['audit-title', $vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4']">DOCUMENTOS EMITIDOS</h1>
      </div>
      <v-spacer />
      <div class="header-right">
        <v-btn icon color="grey darken-3" to="/home">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </header>

    <!-- PANEL DE FILTROS ALTA DENSIDAD ⌨️ -->
    <v-sheet class="filter-dense-panel mb-2 pa-4" elevation="0">
      <v-form ref="form" v-model="valid" @submit.prevent="getReport">
        <v-row dense>
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="criterioReporte"
              :items="['Hoy', 'Ayer', 'Este Mes', 'Rango']"
              label="Criterio"
              dense outlined hide-details class="audit-input"
              color="blue-grey darken-3"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
             <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dates"
                    label="Periodo (Desde - Hasta)"
                    prepend-inner-icon="mdi-calendar"
                    readonly outlined dense hide-details
                    v-bind:rules="dateRules"
                    v-bind="attrs" v-on="on" class="audit-input"
                    color="blue-grey darken-3"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dates" range no-title color="blue-grey darken-3">
                  <v-spacer></v-spacer>
                  <v-btn text @click="dateModal = false">Cancelar</v-btn>
                  <v-btn text color="blue-grey darken-3" @click="$refs.dialog.save(dates)">Aceptar</v-btn>
                </v-date-picker>
              </v-dialog>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="selectedTiposDocumentos"
              :items="tiposDocumentos"
              item-text="documento"
              item-value="tipoDocumento"
              label="Tipo de documento"
              multiple dense outlined hide-details class="audit-input"
              color="blue-grey darken-3"
            >
               <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="caption font-weight-black">{{ selectedTiposDocumentos.length }} selecc.</span>
               </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="selectedEstadosHacienda"
              :items="estadosHacienda"
              label="Estado Hacienda"
              multiple dense outlined hide-details class="audit-input"
              color="blue-grey darken-3"
            >
               <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="caption font-weight-black">{{ selectedEstadosHacienda.length }} selecc.</span>
               </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="selectedMonedas"
              :items="monedas"
              item-text="md_nombre"
              item-value="md_codigo"
              label="Moneda"
              multiple dense outlined hide-details class="audit-input"
              color="blue-grey darken-3"
            >
               <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="caption font-weight-black">{{ selectedMonedas.length }} selecc.</span>
               </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="d-flex align-center">
            <v-btn color="teal darken-2" dark depressed block height="38" @click="getReport" :loading="loading" class="audit-btn">
              <v-icon left size="18">mdi-filter</v-icon>Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense class="mt-2">
          <v-col cols="12" sm="4" md="3">
            <v-text-field
              v-model="reporteEmitidos.nombreReceptor"
              label="Buscar el cliente"
              outlined dense hide-details class="audit-input"
              color="blue-grey darken-3"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="5">
            <v-text-field
              v-model="reporteEmitidos.clave"
              label="Clave Hacienda"
              outlined dense hide-details class="audit-input"
              color="blue-grey darken-3"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="d-flex align-center justify-end">
             <v-btn outlined height="38" color="blue-grey darken-3" class="audit-btn mr-2 px-4 shadow-sm" style="font-size: 0.75rem;" @click="getEmitidos">
                <v-icon left size="18">mdi-refresh</v-icon>Refrescar
             </v-btn>
             
             <vue-excel-xlsx v-if="items2.length > 0" :data="items2" :columns="columns" :filename="'ReporteEmitidos_' + strCia" :sheetname="'Ventas'">
                <v-btn depressed height="38" color="success darken-1" dark class="audit-btn mr-2 px-4 shadow-sm" style="font-size: 0.75rem;">
                  <v-icon left size="18">mdi-microsoft-excel</v-icon>Excel
                </v-btn>
             </vue-excel-xlsx>
             
             <v-btn color="teal darken-2" outlined height="38" @click="sendEmailReport" :disabled="!validEnviarCorreo" class="audit-btn px-4 shadow-sm" style="font-size: 0.75rem;">
                <v-icon left size="18">mdi-email-send-outline</v-icon> Contador
             </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-sheet>

    <!-- TABLA DE AUDITORÍA ALTO CONTRASTE 📊 -->
    <div class="audit-table-container">
      <v-data-table 
        :headers="headers2" 
        :items="filteredItems" 
        class="audit-table audit-zebra"
        fixed-header
        height="calc(100vh - 460px)"
        :loading="loading"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
      >
        <!-- Badge Tipo Doc (Ej: FACT) -->
        <template v-slot:item.tipoDoc="{ item }">
          <div class="doc-badge teal darken-2">{{ item.tipoDoc || 'FACT' }}</div>
        </template>

        <template v-slot:item.estadoHacienda="{ item }">
          <div class="d-flex align-center">
            <v-icon v-if="item.estadoHacienda === 'ACEPTADO'" color="success" size="18">mdi-check-circle</v-icon>
            <v-icon v-else color="error" size="18">mdi-alert-circle</v-icon>
            <span class="ml-1 caption font-weight-bold" :class="item.estadoHacienda === 'ACEPTADO' ? 'success--text' : 'error--text'">
              {{ item.estadoHacienda }}
            </span>
          </div>
        </template>

        <!-- Formato de Columnas -->
        <template v-slot:item.subtotal="{ item }">
          <span class="font-weight-black" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-3' : 'grey--text text--darken-3'">{{ item.totalVentaStr }}</span>
        </template>

        <template v-slot:item.totalImpuesto="{ item }">
          <span class="font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-2' : 'blue-grey--text text--darken-2'">₡ {{ formatPrice(item.totalImpuesto) }}</span>
        </template>

        <template v-slot:item.total="{ item }">
          <span class="font-weight-black" :class="$vuetify.theme.dark ? 'teal--text text--lighten-2' : 'teal--text text--darken-3'">{{ item.totalComprobanteStr }}</span>
        </template>

        <template v-slot:item.montoCosto="{ item }">
          <span class="font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-3' : 'grey--text text--darken-2'">₡ {{ formatPrice(item.montoCosto) }}</span>
        </template>

        <template v-slot:item.ganancia="{ item }">
          <span class="font-weight-black" :class="(item.totalVenta - item.montoCosto) >= 0 ? 'success--text' : 'error--text'">
            ₡ {{ formatPrice(item.totalVenta - item.montoCosto) }}
          </span>
        </template>

        <template v-slot:item.utilidad="{ item }">
          <v-chip v-if="item.totalVenta > 0" small label dark :color="getUtilColor((item.totalVenta - item.montoCosto) / item.totalVenta)" class="font-weight-black">
            {{ (((item.totalVenta - item.montoCosto) / item.totalVenta) * 100).toFixed(2) }}%
          </v-chip>
          <span v-else>0%</span>
        </template>

        <template v-slot:item.actions="{ item }">
           <v-menu offset-y transition="scale-transition" bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal darken-2" dark x-small v-bind="attrs" v-on="on" class="audit-action-btn">
                  Acciones <v-icon right x-small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="pa-0">
                <v-list-item @click="viewPDF(item)">
                  <v-list-item-icon class="mr-2"><v-icon small color="error">mdi-file-pdf-box</v-icon></v-list-item-icon>
                  <v-list-item-title>Ver PDF</v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewEnviado(item)">
                  <v-list-item-icon class="mr-2"><v-icon small color="primary">mdi-xml</v-icon></v-list-item-icon>
                  <v-list-item-title>XML Firmado</v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewRecibido(item)">
                  <v-list-item-icon class="mr-2"><v-icon small color="teal">mdi-check-decagram</v-icon></v-list-item-icon>
                  <v-list-item-title>Respuesta Hacienda</v-list-item-title>
                </v-list-item>
              </v-list>
           </v-menu>
        </template>
      </v-data-table>
    </div>

    <!-- PANEL DE RESUMEN FINANCIERO (FOOTER) 💰 -->
    <v-footer v-if="items2.length > 0" padless class="audit-footer elevation-4 flex-column">
      <!-- FILA 1: DESGLOSE TÉCNICO (RESTAURADO) 📉 -->
      <div class="footer-technical-row d-flex align-center pa-2 px-4 w-full border-bottom overflow-x-auto">
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">EXENTO:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.exento }}</span>
         </div>
         <v-divider vertical class="mx-2" />
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 1%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva1 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 2%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva2 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 4%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva4 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 8%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva8 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 13%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva13 }}</span>
         </div>
         <v-divider vertical class="mx-2" />
         <div class="tech-item">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">OTROS CARGOS:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.otrosCargos }}</span>
         </div>
      </div>

      <!-- FILA 2: RESUMEN GENERAL 💰 -->
      <div class="footer-summary-row d-flex align-center pa-3 w-full">
        <div class="summary-item mr-8">
           <span class="summary-label">TOTAL NETO (SUBTOTAL)</span>
           <v-chip color="grey darken-3" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.ventaNetaRaw }}</v-chip>
        </div>
        <div class="summary-item mr-8 border-left pl-8">
           <span class="summary-label">TOTAL COSTO</span>
           <v-chip color="blue-grey darken-3" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.costoTotalRaw }}</v-chip>
        </div>
        <div class="summary-item">
           <span class="summary-label">TOTAL GANANCIA</span>
           <v-chip color="teal darken-3" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.gananciaRaw }}</v-chip>
        </div>
      </div>
      <div class="footer-util-row d-flex align-center pa-1 px-4 w-full border-top">
         <div class="total-registros caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">
           REGISTROS EN ESTA CONSULTA: <span :class="$vuetify.theme.dark ? 'teal--text text--lighten-2' : 'teal--text text--darken-3'">{{ items2.length }}</span>
         </div>
         <v-spacer />
         <div class="utilidad-global mr-4 caption font-weight-black" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : ''">
           UTILIDAD BRUTA SOBRE VENTAS: <span class="success--text">{{ financialTotals.utilBrutaVenta }}%</span>
         </div>
      </div>
    </v-footer>

    
    <!-- VISOR DE DOCUMENTOS (PDF / XML) REPLICADO DE FACTURACIÓN 📄 -->
    <v-dialog v-model="docViewerDialog" max-width="1100" eager>
      <v-card style="height: 88vh;" class="d-flex flex-column overflow-hidden rounded-xl">
        <div class="doc-viewer-toolbar d-flex align-center px-3 py-2 white--text flex-shrink-0">
          <v-icon color="white" size="18" class="mr-2">mdi-file-document-outline</v-icon>
          <span class="font-weight-bold text-subtitle-2">{{ docViewerTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small dark class="mr-1" @click="abrirEnNuevaPestana" title="Abrir en nueva pestaña">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon x-small dark @click="docViewerDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe v-if="docViewerDialog" :src="docViewerUrl" class="flex-grow-1" style="border: none; width: 100%;"></iframe>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: { Snackbar },
  data() {
    return {
      valid: false, validEnviarCorreo: false, loading: false,
      dateModal: false, dates: [], items2: [], criterion: 'Hoy',
      criterioReporte: 'Hoy', selectedMonedas: [], monedas: [], 
      selectedTiposDocumentos: [], tiposDocumentos: [], selectedEstadosHacienda: [], 
      estadosHacienda: ["ACEPTADO", "RECHAZADO"], opcionesSistemaCia: [],
      snackText: "", snackValue: false,
      docViewerDialog: false, docViewerUrl: '', docViewerTitle: '',
      dateRules: [ (v) => (v && v.length == 2) || "Requerido" ],
      headers2: [
        { text: "CONSECUTIVO", value: "consHacReal", width: 200 },
        { text: "TIPO DOC", value: "tipoDoc", width: 80, align: "center" },
        { text: "FECHA EMISIÓN", value: "fechaString", width: 140 },
        { text: "IDENTIFICACIÓN - CLIENTE", value: "clienteNombre", width: 350 },
        { text: "MONEDA", value: "moneda", width: 80, align: "center" },
        { text: "ESTADO MH", value: "estadoHacienda", width: 130 },
        { text: "SUBTOTAL", value: "subtotal", width: 120, align: "end" },
        { text: "IVA", value: "totalImpuesto", width: 100, align: "end" },
        { text: "COSTO", value: "montoCosto", width: 120, align: "end" },
        { text: "GANANCIA", value: "ganancia", width: 120, align: "end" },
        { text: "UTIL (%)", value: "utilidad", width: 100, align: "center" },
        { text: "TOTAL VENTA", value: "total", width: 140, align: "end" },
        { text: "ACCIONES", value: "actions", sortable: false, align: "center", width: 130 },
      ],
      columns: [
        { label: "Consecutivo", field: "consHacReal" },
        { label: "Clave Hacienda", field: "clavehacienda" },
        { label: "Tipo Documento", field: "tipoDoc" },
        { label: "Fecha Emisión", field: "fechaString" },
        { label: "Nombre Cliente", field: "clienteNombre" },
        { label: "Identificación Cliente", field: "cedulaReceptor" },
        { label: "Moneda", field: "moneda" },
        { label: "Subtotal (Venta Neta)", field: "totalVenta" },
        { label: "Total Descuento", field: "totalDescuentos" },
        { label: "Total Impuesto (IVA)", field: "totalImpuesto" },
        { label: "Total IVA 1%", field: "totalIva1" },
        { label: "Total IVA 2%", field: "totalIva2" },
        { label: "Total IVA 4%", field: "totalIva4" },
        { label: "Total IVA 8%", field: "totalIva8" },
        { label: "Total IVA 13%", field: "totalIva13" },
        { label: "Total Exento", field: "totalExento" },
        { label: "Total Otros Cargos", field: "totalOtrosCargos" },
        { label: "Monto Costo", field: "montoCosto" },
        { label: "Monto Ganancia", field: "ganancia" },
        { label: "Utilidad (%)", field: "utilidad" },
        { label: "Total Comprobante", field: "totalComprobante" },
        { label: "Estado Hacienda", field: "estadoHacienda" },
      ],
      reporteEmitidos: { cia: "", fechaInicio: null, fechaFin: null, docNombre: "Ventas", cedulaReceptor: "", nombreReceptor: "", clave: "", moneda: "", tipoDocumento: "", estadoHacienda: "" },
    };
  },
  computed: {
    ...mapGetters(["user", "strCia"]),
    filteredItems() {
      // Para la tabla en pantalla, quitamos las filas de totales del servidor
      return this.items2.filter(i => i.consHacReal && i.consHacReal.trim() !== '');
    },
    financialTotals() {
      // Los cálculos del dashboard se hacen SOLO sobre documentos reales para no duplicar sumas
      let ventaNeta = this.filteredItems.reduce((acc, i) => acc + (i.totalVenta || 0), 0);
      let costoTotal = this.filteredItems.reduce((acc, i) => acc + (i.montoCosto || 0), 0);
      let ganancia = ventaNeta - costoTotal;
      let utilBrutaVenta = ventaNeta > 0 ? (ganancia / ventaNeta) * 100 : 0;
      
      // DESGLOSE TÉCNICO DE IMPUESTOS (RESTAURADO) 📉
      const iva1 = this.filteredItems.reduce((acc, i) => acc + (i.totalIva1 || 0), 0);
      const iva2 = this.filteredItems.reduce((acc, i) => acc + (i.totalIva2 || 0), 0);
      const iva4 = this.filteredItems.reduce((acc, i) => acc + (i.totalIva4 || 0), 0);
      const iva8 = this.filteredItems.reduce((acc, i) => acc + (i.totalIva8 || 0), 0);
      const iva13 = this.filteredItems.reduce((acc, i) => acc + (i.totalIva13 || 0), 0);
      const exento = this.filteredItems.reduce((acc, i) => acc + (i.totalExento || 0), 0);
      const otrosCargos = this.filteredItems.reduce((acc, i) => acc + (i.totalOtrosCargos || 0), 0);

      return {
        ventaNetaRaw: this.formatPrice(ventaNeta),
        costoTotalRaw: this.formatPrice(costoTotal),
        gananciaRaw: this.formatPrice(ganancia),
        utilBrutaVenta: utilBrutaVenta.toFixed(2),
        // Detalle de impuestos
        iva1: this.formatPrice(iva1),
        iva2: this.formatPrice(iva2),
        iva4: this.formatPrice(iva4),
        iva8: this.formatPrice(iva8),
        iva13: this.formatPrice(iva13),
        exento: this.formatPrice(exento),
        otrosCargos: this.formatPrice(otrosCargos)
      };
    }
  },
  created() { 
    this.getMonedas(); this.getTiposDocumentos(); this.getOpcionesSistemaCia(); 
    this.setDatesByCriterion('Hoy');
  },
  watch: {
    criterioReporte(val) { this.setDatesByCriterion(val); }
  },
  methods: {
    formatPrice(val) { return (val || 0).toLocaleString("es-CR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    getUtilColor(ratio) { if (ratio >= 0.3) return 'success'; if (ratio > 0) return 'warning'; return 'error'; },
    clear() { this.dates = []; this.selectedMonedas = []; this.selectedTiposDocumentos = []; this.selectedEstadosHacienda = []; this.reporteEmitidos = { cia: "", fechaInicio: null, fechaFin: null, docNombre: "Ventas", cedulaReceptor: "", nombreReceptor: "", clave: "", moneda: "", tipoDocumento: "", estadoHacienda: "" }; },
    getReport() { this.getEmitidos(); },
    getOpcionesSistemaCia() { axios.get("api/General/getOpcionesSistemaCia?cia=" + this.strCia).then(r => this.opcionesSistemaCia = r.data); },
    openDocViewer(url, title) {
      this.docViewerUrl = url;
      this.docViewerTitle = title;
      this.docViewerDialog = true;
    },
    abrirEnNuevaPestana() {
      window.open(this.docViewerUrl, '_blank');
    },
    viewPDF(item) {
      const base = axios.defaults.baseURL || "";
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=pdf`,
        "PDF — Comprobante"
      );
    },
    viewEnviado(item) {
      const base = axios.defaults.baseURL || "";
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=signed`,
        "XML Enviado"
      );
    },
    viewRecibido(item) {
      const base = axios.defaults.baseURL || "";
      this.openDocViewer(
        `${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=response`,
        "Respuesta Hacienda"
      );
    },
    getMonedas() { axios.get("api/General/getMonedas").then(r => this.monedas = r.data); },
    getTiposDocumentos() { axios.get("api/General/getTipoDocumentos").then(r => this.tiposDocumentos = r.data); },
    getEmitidos() {
      if (!this.dates || this.dates.length < 2) { this.snackValue = true; this.snackText = "Rango de fechas requerido"; return; }
      this.loading = true; this.items2 = []; let me = this; this.reporteEmitidos.cia = this.strCia;
      const sortedDates = [...this.dates].sort();
      this.reporteEmitidos.fechaInicio = sortedDates[0]; this.reporteEmitidos.fechaFin = sortedDates[1];
      this.reporteEmitidos.moneda = this.selectedMonedas.map(m => typeof m === 'object' ? m.md_codigo : m).join(",");
      this.reporteEmitidos.tipoDocumento = this.selectedTiposDocumentos.map(d => typeof d === 'object' ? d.tipoDocumento : d).join(",");
      this.reporteEmitidos.estadoHacienda = this.selectedEstadosHacienda.join(",");
      axios.post("/api/Reportes/getFacturasReporte", this.reporteEmitidos).then(r => {
        // Guardamos TODO para el Excel (incluyendo totales del server)
        me.items2 = r.data;
        me.loading = false;
        if (me.opcionesSistemaCia) me.validEnviarCorreo = me.opcionesSistemaCia.some(o => o.opcionId === "correo_contador" && o.valor === "true");
      }).catch(() => me.loading = false);
    },
    sendEmailReport() {
      this.reporteEmitidos.cia = this.strCia;
      this.reporteEmitidos.fechaInicio = this.dates[0]; this.reporteEmitidos.fechaFin = this.dates[1];
      this.reporteEmitidos.moneda = this.selectedMonedas.map(m => typeof m === 'object' ? m.md_codigo : m).join(",");
      this.reporteEmitidos.tipoDocumento = this.selectedTiposDocumentos.map(d => typeof d === 'object' ? d.tipoDocumento : d).join(",");
      this.reporteEmitidos.estadoHacienda = this.selectedEstadosHacienda.join(",");
      axios.post("/api/Reportes/enviarCorreoEmitidos", this.reporteEmitidos).then(r => { this.snackValue = true; this.snackText = r.data; });
    },
    setDatesByCriterion(criterion) {
      const today = new Date().toISOString().substr(0, 10);
      const yesterdayDate = new Date(); yesterdayDate.setDate(yesterdayDate.getDate() - 1);
      const yesterday = yesterdayDate.toISOString().substr(0, 10);
      if (criterion === 'Hoy') this.dates = [today, today];
      else if (criterion === 'Ayer') this.dates = [yesterday, yesterday];
      else if (criterion === 'Este Mes') {
        const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10);
        this.dates = [firstDay, today];
      }
    }
  }
};
</script>

<style scoped>
.report-emitidos-container { background: #f5f5f5; min-height: 100vh; }

/* CABECERA AUDIT */
.audit-header { border-bottom: 2px solid #ddd; background: #fff; }
.audit-title { font-size: 1.25rem; font-weight: 900; margin: 0; letter-spacing: 0.5px; }

/* FILTROS */
.filter-dense-panel { border-bottom: 1px solid #eee; background: #fff !important; }
.audit-input >>> .v-input__control > .v-input__slot { border-radius: 0 !important; font-size: 0.75rem; }
.audit-input >>> fieldset { border-radius: 0 !important; border-color: #eee !important; }
.audit-btn { border-radius: 0 !important; font-weight: 700; letter-spacing: 0.5px; }

/* TABLA */
.audit-table >>> th { background-color: #37474f !important; color: #fff !important; font-size: 0.7rem !important; height: 44px !important; }
.audit-zebra >>> tbody tr:nth-child(even) { background-color: #fcfcfc; }

.doc-badge { color: #fff; font-size: 0.6rem; font-weight: 900; padding: 2px 5px; display: inline-block; border-radius: 0; }
.audit-action-btn { border-radius: 0 !important; font-size: 0.65rem !important; font-weight: 800 !important; }

/* FOOTER */
.audit-footer { background: #fff; border-top: 3px solid #37474f; }
.summary-label { font-size: 0.75rem; font-weight: 800; color: #666; }
.border-left { border-left: 1px solid #ddd; }
.total-registros { font-size: 0.7rem; }
.utilidad-global { font-size: 0.75rem; }
.doc-viewer-toolbar { background: linear-gradient(135deg, #37474f 0%, #455a64 100%); min-height: 44px; }
.w-full { width: 100%; }
* { border-radius: 0 !important; }

/* ══════════════ MODO OSCURO ══════════════ */
.dark-mode { background: #121212 !important; color: #e0e0e0; }

/* Cabecera */
.dark-mode >>> .audit-header { background: #1a1a1a !important; border-bottom-color: #333 !important; }

/* Panel de filtros */
.dark-mode >>> .filter-dense-panel { background: #1e1e1e !important; border-bottom-color: #333 !important; }
.dark-mode >>> .audit-input .v-input__slot { background: #2a2a2a !important; }
.dark-mode >>> .audit-input fieldset { border-color: #455a64 !important; }
.dark-mode >>> .audit-input .v-label { color: #78909c !important; }
.dark-mode >>> .audit-input input,
.dark-mode >>> .audit-input .v-select__selection { color: #e0e0e0 !important; }
.dark-mode >>> .audit-input .v-input__icon .v-icon { color: #78909c !important; }
.dark-mode >>> .v-divider { border-color: #333 !important; }

/* Tabla */
.dark-mode >>> .v-data-table { background: #121212 !important; }
.dark-mode >>> .v-data-table tbody tr { background: #1a1a1a !important; color: #cfd8dc; }
.dark-mode >>> .v-data-table tbody tr:nth-child(even) { background: #1f1f1f !important; }
.dark-mode >>> .v-data-table tbody tr:hover { background: #263238 !important; }
.dark-mode >>> .v-data-table td { border-bottom: 1px solid #272727 !important; color: #cfd8dc !important; }
.dark-mode >>> .v-data-footer { background: #1a1a1a !important; border-top-color: #333 !important; color: #78909c !important; }
.dark-mode >>> .v-data-footer .v-btn { color: #90a4ae !important; }
/* Corregir colores Vuetify hardcoded en slots */
.dark-mode >>> .grey--text.text--darken-2,
.dark-mode >>> .grey--text.text--darken-3,
.dark-mode >>> .grey--text.text--darken-4 { color: #90a4ae !important; }
.dark-mode >>> .teal--text.text--darken-3 { color: #4db6ac !important; }
.dark-mode >>> .blue-grey--text.text--darken-2 { color: #80cbc4 !important; }

/* Menú de acciones */
.dark-mode >>> .v-menu__content .v-list { background: #1e1e1e !important; }
.dark-mode >>> .v-menu__content .v-list-item:hover { background: rgba(255,255,255,0.06) !important; }
.dark-mode >>> .v-menu__content .v-list-item__title { color: #e0e0e0 !important; }

/* Footer */
.dark-mode >>> .audit-footer { background: #1a1a1a !important; border-top-color: #455a64 !important; }
.dark-mode >>> .footer-technical-row { background: rgba(255,255,255,0.03) !important; border-bottom-color: #2e2e2e !important; }
.dark-mode >>> .footer-util-row { border-top-color: #2e2e2e !important; }
.dark-mode >>> .border-left { border-left-color: #37474f !important; }
.dark-mode >>> .summary-label { color: #78909c !important; }
.dark-mode >>> .tech-value { color: #cfd8dc !important; }
.dark-mode >>> .total-registros { color: #607d8b !important; }
.dark-mode >>> .utilidad-global { color: #90a4ae !important; }
</style>